import React, { useEffect, useRef } from 'react';
import { Ellipsis } from 'lucide-react';
import { TECHNICIAN_MENU_DROPDOWN_WIDTH } from '../constants/technicianMenuConstants';
import './TechnicianMenuModals.css';

export function TechnicianMenuTrigger({
  technician,
  isOpen = false,
  onToggle,
  onPositionUpdate,
}) {
  const menuButtonRef = useRef(null);

  useEffect(() => {
    if (!isOpen || !menuButtonRef.current) return undefined;

    const timeoutId = window.setTimeout(() => {
      if (!menuButtonRef.current) return;
      const rect = menuButtonRef.current.getBoundingClientRect();
      onPositionUpdate?.(technician, {
        top: rect.bottom + 4,
        left: rect.right - TECHNICIAN_MENU_DROPDOWN_WIDTH,
      });
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [isOpen, technician, onPositionUpdate]);

  return (
    <div className="technician-menu-container board-clickup-icon-btn-anchor">
      <div
        ref={menuButtonRef}
        className="technician-menu-icon"
        onClick={() => onToggle?.(technician)}
        role="button"
        tabIndex={0}
        aria-label="Menu do técnico"
        aria-haspopup="true"
        aria-expanded={Boolean(isOpen)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggle?.(technician);
          }
        }}
      >
        <Ellipsis size={15.4} strokeWidth={2.2} aria-hidden />
      </div>
      {!isOpen ? (
        <span className="board-clickup-tooltip board-clickup-tooltip--bottom" role="tooltip">
          Menu do técnico
        </span>
      ) : null}
    </div>
  );
}
